/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationsTypeEnum } from './NotificationsTypeEnum';
import {
  NotificationsTypeEnumFromJSON,
  NotificationsTypeEnumFromJSONTyped,
  NotificationsTypeEnumToJSON,
} from './NotificationsTypeEnum';

/**
 *
 * @export
 * @interface Notifications
 */
export interface Notifications {
  /**
   *
   * @type {number}
   * @memberof Notifications
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof Notifications
   */
  user: string;
  /**
   *
   * @type {NotificationsTypeEnum}
   * @memberof Notifications
   */
  type?: NotificationsTypeEnum;
  /**
   *
   * @type {string}
   * @memberof Notifications
   */
  sender?: string;
  /**
   *
   * @type {string}
   * @memberof Notifications
   */
  text?: string;
  /**
   *
   * @type {boolean}
   * @memberof Notifications
   */
  unread?: boolean;
  /**
   *
   * @type {Date}
   * @memberof Notifications
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof Notifications
   */
  uuid?: string;
}

/**
 * Check if a given object implements the Notifications interface.
 */
export function instanceOfNotifications(value: object): value is Notifications {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('user' in value) || value['user'] === undefined) return false;
  return true;
}

export function NotificationsFromJSON(json: any): Notifications {
  return NotificationsFromJSONTyped(json, false);
}

export function NotificationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Notifications {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    user: json['user'],
    type: json['type'] == null ? undefined : NotificationsTypeEnumFromJSON(json['type']),
    sender: json['sender'] == null ? undefined : json['sender'],
    text: json['text'] == null ? undefined : json['text'],
    unread: json['unread'] == null ? undefined : json['unread'],
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    uuid: json['uuid'] == null ? undefined : json['uuid'],
  };
}

export function NotificationsToJSON(value?: Omit<Notifications, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    user: value['user'],
    type: NotificationsTypeEnumToJSON(value['type']),
    sender: value['sender'],
    text: value['text'],
    unread: value['unread'],
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    uuid: value['uuid'],
  };
}
